<script lang="ts" setup>
import CheckboxFilter from './components/checkboxFilter/CheckboxFilter.vue';
import RadioButtonFilter from './components/radioButtonFilter/RadioButtonFilter.vue';
import RangeSliderFilter from './components/rangeSliderFilter/RangeSliderFilter.vue';
import SliderFilter from './components/sliderFilter/SliderFilter.vue';
import { FilterType } from './Filters.model';
import type { FiltersEvents, FilterTypes } from './Filters.model';

interface FiltersProps {
  data: FilterTypes[];
}

const props = defineProps<FiltersProps>();

interface FiltersGroupEmits {
  (eventName: 'update', context: FiltersEvents): void;
}

const emit = defineEmits<FiltersGroupEmits>();

function update(action: FiltersEvents): void {
  emit('update', action);
}
</script>

<template>
  <div class="filters-group">
    <!-- TODO: Add proper key -->
    <template v-for="filter in props.data" :key="filter.filterType">
      <CheckboxFilter
        v-if="filter.filterType === FilterType.Checkbox"
        class="checkbox-filter"
        :data="filter"
        @update="update"
      />
      <RadioButtonFilter
        v-if="filter.filterType === FilterType.RadioButton"
        class="radio-button-filter"
        :data="filter"
        @update="update"
      />
      <RangeSliderFilter
        v-if="filter.filterType === FilterType.RangeSlider"
        class="range-slider-filter"
        :data="filter"
        @update="update"
      />
      <SliderFilter
        v-if="filter.filterType === FilterType.Slider"
        class="slider-filter"
        :data="filter"
        @update="update"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.filters-group {
  .radio-button-filter,
  .range-slider-filter,
  .slider-filter {
    display: flex;
    flex-direction: column;
  }

  .radio-button-filter:not(:last-child),
  .range-slider-filter:not(:last-child),
  .slider-filter:not(:last-child) {
    margin-bottom: var(--spacing-24);
  }

  .checkbox-filter:not(:last-child) {
    margin-bottom: var(--spacing-16);
  }
}
</style>
